import React from 'react';
import { clsx } from 'clsx';
import { t } from '../../i18n/t';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullPage?: boolean;
}

const sizeClass = { sm: 'w-4 h-4 border-2', md: 'w-8 h-8 border-3', lg: 'w-12 h-12 border-4' };

export default function LoadingSpinner({ size = 'md', className, fullPage }: LoadingSpinnerProps) {
  const spinner = (
    <div
      className={clsx(
        'border-amber-strong border-t-transparent rounded-full animate-spin',
        sizeClass[size],
        className,
      )}
      role="status"
      aria-label={t('common:loadingSpinner.loading')}
    />
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-paper z-50">
        {spinner}
      </div>
    );
  }
  return spinner;
}
